'use client'

import { useSupportAccess } from '@/hooks/business/auth/useSupportAccess'
import TopStripe from '../TopStripe'

/**
 * Faixa "Acesso de suporte" na sessão aberta pelo atendente. O `useSupportAccess` lê a store: na hidratação vale o
 * estado inicial (igual ao do servidor, que não conhece a sessão), e a faixa aparece logo depois.
 */
const SupportStripe: React.FC = () => {
    const isSupportAccess = useSupportAccess()

    return isSupportAccess ? <TopStripe title="Acesso de suporte" /> : null
}

export default SupportStripe
